import {DataGrid} from '@mui/x-data-grid';



import {useState, useEffect} from "react";

import * as React from "react";
import {darken, lighten, Tooltip} from "@mui/material";
import Box from "@mui/material/Box";

import {
    getContractCS
} from "../../ContractSection/ContractSectionClient";
import Typography from "@mui/material/Typography";





// by including the props in this function it says to send something back to the parent
function WorkDashboardCSGrid(props) {
    const [drilldownCS, setDrilldownCS] = useState([]);
    const [allCS, setAllCS] = useState([]);
    const [filteredCS, setFilteredCS] = useState([]);
    const [contractSectionId, setContractSectionId] = useState([]);

    const [selectedContractId, setSelectedContractId] = useState(props.contractIdq)
    //
    useEffect(() => {
        if (props.contractIdq !== selectedContractId) {
            setSelectedContractId(props.contractIdq);
            console.log("this is my selectedContractId");
            console.log(props.contractIdq)
            console.log(selectedContractId)
            console.log("this is my filtered filters data");
            console.log(allCS.filter(allCS => allCS.contractId == props.contractIdq));
            setFilteredCS(allCS.filter(allCS => allCS.contractId ==  props.contractIdq));
        }
    }, [props.contractIdq]);




    const fetchDrilldownCS = () =>
        getContractCS(99)

            .then(data => {
                console.log(data);
                setDrilldownCS(data);
                setAllCS(data);
                // setFilteredCS(data.filter(allCS => allCS.contractId ==  props.contractIdq));
                // setFilteredCS(data.filter(allCS => allCS.contractId ==  99));
                setFilteredCS(data);
                // setFilteredCS(data.filter(allCS => allCS.contractId ==  props.contractId));
                console.log("this is my filtered sections data");
                console.log(filteredCS);
            })
    useEffect(() => {
        console.log("This is working so far...");
        fetchDrilldownCS();
    }, []);
    const renderContractSections2 = drilldownCS => {
        if (drilldownCS.length <= 0) {
            return "No Data";
        }}

    function onChange(pagination, filters, sorter, extra) {
        console.log('params', pagination, filters, sorter, extra);
    }


    const handleExplore = (drilldownCSId, rowElement, rowFull) => {
        setContractSectionId(drilldownCSId);
        // this props thing sends the contract section id to the parent component
        props.passContractSectionIdP(drilldownCSId);
        // setContractSectionId2(drilldownCSId);
        console.log("This is what was received");
        console.log(drilldownCSId);
        console.log("This is the contract section chosen");
        console.log(contractSectionId);
        // console.log("Here's the element");
        // console.log(rowElement);
        // console.log("Here's the row");
        // console.log(rowFull);
        // console.log("Here's the mcode from the row");
        // console.log(rowFull[1]);
        // console.log("Here's the stringify");
        // getContractById(contractIdX);
        // console.log(JSON.stringify(getContractById, null, 2))
    }


    const columns = fetchDrilldownCS => [
        // {
        //     field: "contractExplore",
        //     headerName: '',
        //     width: 30,
        //     padding: 0,
        //     margin: 0,
        //     sortable: false,
        //     menu: false,
        //     filter: false,
        //     renderCell: (drilldownCS) => {
        //         return (
        //             <IconButton
        //                 size="small"
        //                 variant="contained"
        //                 color="primary"
        //             >
        //                 <InfoIcon onClick= {() => handleExplore(drilldownCS.row.id, drilldownCS.row.name, drilldownCS.row)}/>
        //             </IconButton>
        //         );
        //     }
        // },
        {    field: 'contractId',
            headerName: 'cid',
            description: '',
            sortable: false,
            width: 60,
            hide: true,
        },
        {    field: 'id',
            headerName: 'id',
            description: '',
            sortable: false,
            width: 60,
            hide: true,
        },
        {    field: 'ordinalNumber',
            headerName: '#',
            description: '',
            sortable: false,
            width: 60,
        },
        {
            field: 'recordLevel',
            headerName: 'Level',
            description: '',
            sortable: false,
            // editable: true,
            width: 60,
            hide: true,
        },
        {
            field: 'name',
            headerName: 'Name',
            description: '',
            sortable: false,
            width: 300,
            // '& .level--1': {lm: 0},
            // '& .level--2': {lm: 2},
            // '& .level--3': {lm: 4},
            // '& .level--4': {lm: 6},
            // '& .level--5': {lm: 8},
            // '& .level--6': {lm: 10},
            // '& .level--7': {lm: 12},
            // '& .level--8': {lm: 14},
            // '& .level--9': {lm: 16},
            // '& .level--10': {lm: 18}
            renderCell: (filteredCS) => {
                return (<Tooltip placement={'right-end'} title={<span style={{whiteSpace: 'pre-line'}}>
                    {"from:\n" + filteredCS.row.contractId +
                        "\n\ndetails:"
                        + "\n" + filteredCS.row.contractLevel
                        + "\n" + filteredCS.row.id
                    }</span>}>
                    <p onClick= {() => handleExplore(filteredCS.row.id, filteredCS.row.name, filteredCS.row)}>
                        {filteredCS.row.name} </p>
                    </Tooltip>
                );}
        },
        {
            field: 'description',
            headerName: 'Description',
            description: '',
            sortable: false,
            editable: false,
            // editable: true,
            width: 500,
            hide: false,
            renderCell: (filteredCS) => {
                return (
                    <p onDoubleClick={() => handleExplore(filteredCS.row.id, filteredCS.row.description, filteredCS.row)}>
                        {filteredCS.row.description} </p>
                );}
        },

    ];


    const getBackgroundColor = (color, mode) =>
        mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

    const getHoverBackgroundColor = (color, mode) =>
        mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);




    return (

        <Box
            // style={{ height: '100%' , width: '100%' }}
            sx={{
                height: 700,
                width: 1,
                // '& .level--1': {
                //     bgcolor: (theme) =>
                //         getBackgroundColor(theme.palette.info.main, theme.palette.mode),
                //     '&:hover': {
                //         bgcolor: (theme) =>
                //             getHoverBackgroundColor(theme.palette.info.main, theme.palette.mode),
                //     },
                // },
                // '& .level--2': {
                //     bgcolor: (theme) =>
                //         getBackgroundColor(theme.palette.success.main, theme.palette.mode),
                //     '&:hover': {
                //         bgcolor: (theme) =>
                //             getHoverBackgroundColor(
                //                 theme.palette.success.main,
                //                 theme.palette.mode,
                //             ),
                //     },
                // }
                '& .level--1': {backgroundColor: "rgb(30,144,255)"},//https://html-color.codes/blue dodger blue
                '& .level--2': {backgroundColor: "rgb(69,177,232)"},//https://html-color.codes/blue picton blue
                '& .level--3': {backgroundColor: "rgb(135,206,250)"},//https://html-color.codes/blue lightskyblue
                '& .level--4': {backgroundColor: "rgb(137,207,240)"},//https://html-color.codes/blue baby blue
                '& .level--5': {backgroundColor: "rgb(173,216,230)"},//https://html-color.codes/blue light blue
                '& .level--6': {backgroundColor: "rgb(135,206,235)"},//https://html-color.codes/blue skyblue
                '& .level--7': {backgroundColor: "rgb(231,254,255)"},//https://html-color.codes/blue bubbles
                '& .level--8': {backgroundColor: "rgb(244,240,236)"},//https://html-color.codes/grey isabelline
                '& .level--9': {backgroundColor: "rgb(250,250,250)"},//custom
                '& .level--10': {backgroundColor: "rgb(255,255,255)"},//custom


                // '& .level--2': {backgroundColor: '#CCFF00'}
            }}
        >


                <Box
                    //     sx={{ fontWeight: 'bold',
                    //         fontSize: 20
                    //         // fontSize: 'h1.fontSize'
                    // }}
                    // sx={{mr: 0, mb: 0, verticalAlign: 'bottom'}}
                >
                    {/*<h3 >Contract Data Points*/}
                    {/*    /!*{props.selectedSection} {selectedSection} *!/*/}
                    {/*</h3>*/}
                    <Typography sx={{ fontWeight: 'bold'
                        // htmlFontSize: 48
                        // fontsize: 48
                    }} >Matt's Dashboards</Typography>
                </Box>
            <DataGrid
                style={{ height: '100% - 20px', width: '100%', cursor: 'pointer'}}
                aria-label={"fetchDrilldownCS"}
                // components={{ Toolbar: GridToolbar }}
                // rows={drilldownCS}
                rows={filteredCS}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={columns(fetchDrilldownCS)}
                density={"compact"}
                pageSize={100}
                rowsPerPageOptions={[100]}
                // getRowClassName={(drilldownCS) => `level--${drilldownCS.row.recordLevel}`}
                getRowClassName={(filteredCS) => `level--${filteredCS.row.recordLevel}`}
                // getRowClassName={(drilldownCS) => 'level--2'}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'ordinalNumber', sort: 'asc' }],
                    },
                    // filter: {
                    //     filterModel: {
                    //         items: [
                    //             {
                    //                 columnField: 'ontractId',
                    //                 operatorValue: 'equals',
                    //                 value: {props.contractIdq}
                    //             }],
                    //     },
                    // }
                }}
            />
        </Box>

    );


}
export default WorkDashboardCSGrid;



